<template>
  <div class="staff-loan-audit-tags">
    <span
      v-for="tag in tags"
      :key="tag.code"
      :style="{ backgroundColor: tag.color }"
      class="status-tag staff-loan-audit-tags__tag"
    >
      {{ tag.name }}
    </span>
    <span v-if="!tags.length">-</span>
  </div>
</template>

<script>
const auditFlagLabels = {
  payroll_missing: 'Payroll missing',
  payroll_has_zero_advances: 'Payroll zero',
  payroll_aggregate_mismatch: 'Payroll mismatch',
  legacy_schedule_only: 'Legacy only',
  payroll_multiple_candidates: 'Payroll multiple candidates',
  payroll_month_mismatch: 'Payroll month mismatch',
}

const auditFlagColors = {
  payroll_missing: '#DC2626',
  payroll_has_zero_advances: '#F59E0B',
  payroll_aggregate_mismatch: '#EA580C',
  legacy_schedule_only: '#0F766E',
  payroll_multiple_candidates: '#64748B',
  payroll_month_mismatch: '#64748B',
}

export default {
  name: 'ScheduleAuditTags',
  props: {
    schedule: {
      type: Object,
      required: true,
    },
  },
  computed: {
    tags() {
      const tags = []
      const flags = this.schedule.migration_audit_flags || []

      if (this.schedule.is_payroll_confirmed && this.schedule.proof_type === 'completed_payroll') {
        tags.push({ code: 'payroll_confirmed', name: 'Payroll confirmed', color: '#0F766E' })
      }

      if (this.schedule.proof_type === 'historical_snapshot_exact') {
        tags.push({ code: 'payroll_snapshot', name: 'Payroll snapshot', color: '#2563EB' })
      }

      flags.forEach(flag => {
        tags.push({
          code: flag,
          name: auditFlagLabels[flag] || this.formatFlag(flag),
          color: auditFlagColors[flag] || '#64748B',
        })
      })

      if (this.schedule.is_legacy_confirmed) {
        tags.push({ code: 'legacy_schedule', name: 'Legacy schedule', color: '#0F766E' })
      }

      return tags
    },
  },
  methods: {
    formatFlag(flag) {
      return flag
        .split('_')
        .map(part => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' ')
    },
  },
}
</script>

<style scoped lang="sass">
.staff-loan-audit-tags
  display: flex
  flex-wrap: wrap
  gap: 4px

.staff-loan-audit-tags__tag
  margin: 0
  white-space: nowrap
</style>
